import { ADD_API_ERROR, REMOVE_API_ERROR } from './constants';

const INITIAL_STATE = null;

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_API_ERROR: {
      return formatApiError(action.payload);
    }
    case REMOVE_API_ERROR: {
      return null;
    }
    default:
      return state;
  }
};

export default reducer;

const formatApiError = (apiResponse) => {
  let output = '';
  if (apiResponse.response?.data?.errors) {
    output = apiResponse.response.data.errors.reduce((string, err) => {
      let newString = string;
      newString += `The field: "${err.field}" errored because "${err.message}" .`;
      return newString;
    }, '');
    output = `Error from server: ${apiResponse.response.data.message}. ${output}`;
  } else if (apiResponse.response?.data?.message) {
    output = `Error from server: ${apiResponse.response.data.message}. ${output}`;
  } else if (apiResponse.message === 'Network Error') {
    output =
      'Network error.  Either internet connection is unavailable or the remote server is unavailable';
  } else {
    // eslint-disable-next-line no-console
    console.log(apiResponse);
    output = 'Error from server: Something went wrong';
  }
  return output;
};
